<template>
  <!-- 实用计算器 -->
  <div id="DeskCalc">

    <div class="DCalccont between">
      <div class="DCalcside">
        <div class="title">实用计算器</div>
        <ul>
          <li class="between" 
          v-for="(item,index) in 6" 
          :key="index"
          :class="{liactiv:index==routeactiv}"
          @click="routeactiv=index"
          >
            <div>诉讼费计算器</div>
            <svg-icon icon-class="jt_right" />
          </li>
        </ul>
      </div>
      <router-view class="Dchildcont" />
    </div>

  </div>
</template>

<script>

export default {
  name: "DeskCalc",
  data:()=>({
      routeactiv:0
  }),
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
#DeskCalc {
  background-color: #f8f8f8;

  .DCalccont {
    width: 1200px;
    margin: 0 auto;
    padding: 50px 0;
    align-items: flex-start;
    .DCalcside {
      width: 200px;
      background: #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(4, 0, 0, 0.05);
      .title {
        text-align: center;
        width: 200px;
        height: 50px;
        line-height: 50px;
        background: #0465ea;
        font-size: 20px;
        color: #ffffff;
      }
      ul {
        li {
          padding: 0 18px;
          width: 200px;
          height: 44px;
          background: #fff;
          font-size: 14px;
          color: #333333;
          line-height: 44px;
          cursor: pointer;
          .svg-icon{
              color:#999;
          }
          &.liactiv {
            color: #0465ea;
            background: #f1f7ff;
          }
        }
      }
    }
    .Dchildcont {
      width: 975px;
      box-shadow: 0px 0px 10px 0px rgba(4, 0, 0, 0.05);
    }
  }
}
</style>
